module.exports = __webpack_public_path__ + "static/media/study 201024.e022d289.png";